module.exports = Em.TextField.extend({
    attributeBindings: ['type', 'value', 'name', 'disabled', 'autocomplete', 'readonly', 'inputmode', 'cy:data-cy']
});
